"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./Alert.scss");
var classnames_1 = __importDefault(require("classnames"));
var shortid_1 = __importDefault(require("shortid"));
var AlertStatus;
(function (AlertStatus) {
    AlertStatus["SUCCESS"] = "success";
    AlertStatus["DANGER"] = "danger";
})(AlertStatus = exports.AlertStatus || (exports.AlertStatus = {}));
var Alert = function (props) {
    var _a = props.dusk, dusk = _a === void 0 ? null : _a, label = props.label, _b = props.description, description = _b === void 0 ? null : _b, status = props.status;
    var state = {
        'alert--success': status === AlertStatus.SUCCESS,
        'alert--danger': status === AlertStatus.DANGER,
    };
    var shortId = shortid_1.default();
    function removeAlert(id) {
        var _a;
        (_a = window.document.querySelector("#alert-" + id)) === null || _a === void 0 ? void 0 : _a.remove();
    }
    return (react_1.default.createElement("div", { id: "alert-" + shortId, className: classnames_1.default('alert', state), role: "alert", "data-dusk": dusk },
        react_1.default.createElement("div", { className: "flex justify-between" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "alert__label" }, label),
                description && react_1.default.createElement("p", { className: "alert__description" }, description)),
            react_1.default.createElement("button", { onClick: function () { return removeAlert(shortId); }, className: "text-xl leading-none font-bold focus:outline-none" }, "\u00D7"))));
};
exports.default = Alert;
//# sourceMappingURL=Alert.js.map